import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import cloneDeep from 'lodash/cloneDeep';

import { addStateFetch } from '@webapp/account/src/resources/store-utils';

import { orderedMoveAndSortByIndex, updateItemInArray } from '@webapp/common/lib/utils';

import { initialPage } from '../common';

import { addPage, copyPage, getPageList, removePage, reorderPages, updatePageSettings } from './async';
import { initialState } from './pages';

export const pagesSlice = createSlice({
    name: 'pages',
    initialState,
    reducers: {
        selectPage(s, { payload: { pageId } }: PayloadAction<{ pageId: number; surveyId: number }>) {
            s.activePageId = pageId;
        },
        setQuestionCount(
            s,
            { payload: { pageId, questionCount } }: PayloadAction<{ pageId: number; questionCount: number }>,
        ) {
            const p = s.pages.find(({ id }) => id === pageId);
            p.questionCount = questionCount;
        },
    },
    extraReducers: (builder) =>
        addStateFetch(
            builder
                .addCase(updatePageSettings.fulfilled, ({ pages }, { payload: { pageId, params } }) => {
                    updateItemInArray(pages, pageId, (p: any) => {
                        Object.assign(p, params);
                        p.fresh = false;
                    });
                })
                .addCase(removePage.fulfilled, (s, { payload: { pageId } }) => {
                    s.pages = s.pages.filter(({ id }) => id !== pageId);

                    if (s.pages.length > 0) {
                        s.activePageId = s.pages[0].id;
                    }
                })
                .addCase(copyPage.fulfilled, ({ pages }, { payload: { name, newPageId, pageId } }) => {
                    const idx = pages.findIndex(({ id }) => id === pageId);
                    pages.splice(idx + 1, 0, {
                        ...cloneDeep(initialPage),
                        id: newPageId,
                        name,
                    });
                })
                .addCase(reorderPages.pending, ({ pages }, { meta: { arg } }) => {
                    const { newOrder, oldOrder } = arg;
                    orderedMoveAndSortByIndex(pages, oldOrder, newOrder);
                })
                .addCase(getPageList.fulfilled, (s, { payload: { pages, refresh } }) => {
                    s.pages = pages;
                    if (!refresh) {
                        s.activePageId = pages[0] ? pages[0].id : null;
                    }
                })
                .addCase(addPage.fulfilled, (state, { payload }) => {
                    const { id } = payload;

                    state.activePageId = id;
                }),
        ),
});
